import { useMutation, useQueryClient } from "@tanstack/react-query";

import { USER_QUERY_KEY } from "../../hooks/useFetchUserInfo";
import { axiosInstance } from "../../lib/axios";

export const useUpdateUserName = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name: string) =>
      axiosInstance.post<{ success: boolean }>("/user", { name }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY });
    },
  });
};
